import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { stringToArray } from '../../../assets/js/functions';
import { getUsuarioActivo } from '../../../assets/js/getUsuarioActivo';
import { esExperto } from '../../../assets/js/expertos';
import { useLogout } from '../../../hooks/useLogout';

// Íconos
import { MdDashboard } from 'react-icons/md';
import { FaUserFriends, FaIdBadge } from 'react-icons/fa';
import { RiChat3Line } from 'react-icons/ri';
import { HiOutlineChartPie } from 'react-icons/hi';
import { MdPoll } from 'react-icons/md';
import { AiOutlineCaretDown, AiOutlineCaretUp, AiFillHome } from 'react-icons/ai';
import { BiCommentDetail, BiUser } from 'react-icons/bi';
import { GiGraduateCap } from 'react-icons/gi';
import { IoSettings, IoExit } from 'react-icons/io5';
import { BsPersonGear } from 'react-icons/bs';
import { BsCalendarWeek } from 'react-icons/bs';
import { MdManageSearch } from 'react-icons/md';

export const SidebarGlobal = () => {
  const [openAdministrar, setOpenAdministrar] = useState(false);
  const [openUsuarios, setOpenUsuarios] = useState(false);
  const [openPerfiles, setOpenPerfiles] = useState(false);
  const [perfilUsuario, setPerfilUsuario] = useState('');
  const [usuario, setUsuario] = useState(null);
  const navigate = useNavigate();
  const logout = useLogout();

  const seccion = stringToArray(window.location.pathname, '/')[2];
  const seccionDropdown = stringToArray(window.location.pathname, '/')[3];

  useEffect(() => {
    const usuarioData = getUsuarioActivo();
    if (usuarioData) {
      setPerfilUsuario(usuarioData.perfil);
      setUsuario(usuarioData);
    }

    if (['usuarios', 'expertos', 'perfiles', 'dashboard', 'foros', 'reportes'].includes(seccion)) {
      setOpenAdministrar(true);
    }

    if (seccion === 'usuarios' || seccion === 'expertos') setOpenUsuarios(true);
    if (seccion === 'perfiles') setOpenPerfiles(true);
  }, [seccion]);

  const goUrl = (url) => navigate(url);

  const toggleAdministrar = () => setOpenAdministrar(!openAdministrar);

  // Función para obtener las iniciales del usuario
  const getInitials = (nombre) => {
    if (!nombre) return 'U';
    const words = nombre.split(' ');
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return nombre[0].toUpperCase();
  };

  // Función para obtener el nombre completo para mostrar
  const getDisplayName = () => {
    if (usuario) {
      // Si hay nombre y apellido separados
      if (usuario.nombre && usuario.apellido) {
        return `${usuario.nombre} ${usuario.apellido}`;
      }
      // Si solo hay nombre
      if (usuario.nombre) {
        return usuario.nombre;
      }
      // Si hay un campo nombreCompleto
      if (usuario.nombreCompleto) {
        return usuario.nombreCompleto;
      }
    }
    return 'Usuario';
  };

  return (
    <div className='sidebar-body'>
      {/* Header del usuario */}
      <div className='sidebar-user-section'>
        <div className='user-avatar'>
          <div className='avatar-circle'>
            <span className='avatar-letter'>{getInitials(getDisplayName())}</span>
          </div>
        </div>
        <div className='user-info'>
          <span className='user-name'>{getDisplayName()}</span>
          <span className='user-subtitle'>{perfilUsuario || 'Usuario'}</span>
        </div>
      </div>

      {/* MENÚ PRINCIPAL */}
      <div className='sidebar-menu'>
        <ul className='menu-list'>
          <li className='menu-item'>
            <div onClick={() => goUrl('/home')} className={`menu-link ${seccion === 'home' ? 'active' : ''}`}>
              <span className='menu-link-icon'>
                <AiFillHome size={16} />
              </span>
              <span className='menu-link-text'>Home</span>
            </div>
          </li>
          <li className='menu-item'>
            <div onClick={() => navigate('/foro/subdisciplinas')} className={`menu-link ${seccion === 'subdisciplinas' ? 'active' : ''}`}>
              <span className='menu-link-icon'>
                <BiCommentDetail size={16} />
              </span>
              <span className='menu-link-text'>Foro</span>
            </div>
          </li>
          <li className='menu-item'>
            <div onClick={() => goUrl('/home')} className='menu-link'>
              <span className='menu-link-icon'>
                <GiGraduateCap size={16} />
              </span>
              <span className='menu-link-text'>Expertos</span>
            </div>
          </li>
          <li className='menu-item'>
            <div onClick={() => goUrl('/mis-sesiones')} className={`menu-link ${seccion === 'mis-sesiones' ? 'active' : ''}`}>
              <span className='menu-link-icon'>
                <MdPoll size={16} />
              </span>
              <span className='menu-link-text'>Mis sesiones</span>
            </div>
          </li>
          {esExperto(usuario) && (
            <li className='menu-item'>
              <div onClick={() => goUrl('/mi-horario')} className={`menu-link ${seccion === 'mi-horario' ? 'active' : ''}`}>
                <span className='menu-link-icon'>
                  <BsCalendarWeek size={16} />
                </span>
                <span className='menu-link-text'>Mi horario</span>
              </div>
            </li>
          )}
        </ul>
      </div>

      {/* ADMINISTRAR - Solo para administradores */}
      {['Admin', 'administrador', 'superAdmin', 'Super Administrador', 'dev'].includes(perfilUsuario) && (
        <div className='sidebar-menu'>
          <div className='menu-section-header'>
            <div onClick={toggleAdministrar} className='menu-section-toggle'>
              <span className='section-icon'>
                <BsPersonGear size={16} />
              </span>
              <span className='section-title'>Administrar</span>
              <span className='toggle-icon'>{openAdministrar ? <AiOutlineCaretUp size={14} /> : <AiOutlineCaretDown size={14} />}</span>
            </div>
          </div>

          {openAdministrar && (
            <ul className='menu-list'>
              <li className='menu-item'>
                <div onClick={() => goUrl('/admin/dashboard')} className={`menu-link ${seccion === 'dashboard' ? 'active' : ''}`}>
                  <span className='menu-link-icon'>
                    <MdDashboard size={16} />
                  </span>
                  <span className='menu-link-text'>Dashboard</span>
                </div>
              </li>

              {/* Usuarios */}
              {/* <li className='menu-item'>
                <div onClick={() => navigate('/admin/usuarios')} className={`menu-link ${seccion === 'usuarios' ? 'active' : ''}`}>
                  <span className='menu-link-icon'>
                    <FaUserFriends size={16} />
                  </span>
                  <span className='menu-link-text'>Usuarios</span>
                </div>
              </li> */}

              {/* Expertos */}
              <li className='menu-item'>
                <div onClick={() => navigate('/admin/expertos')} className={`menu-link ${seccion === 'expertos' ? 'active' : ''}`}>
                  <span className='menu-link-icon'>
                    <FaUserFriends size={16} />
                  </span>
                  <span className='menu-link-text'>Expertos</span>
                </div>
              </li>

              {/* Foros */}
              <li className='menu-item'>
                <div onClick={() => goUrl('/admin/foros')} className={`menu-link ${seccion === 'foros' ? 'active' : ''}`}>
                  <span className='menu-link-icon'>
                    <RiChat3Line size={16} />
                  </span>
                  <span className='menu-link-text'>Foros</span>
                </div>
              </li>

              {/* Logs — solo dev */}
              {perfilUsuario === 'dev' && (
                <li className='menu-item'>
                  <div onClick={() => goUrl('/admin/dashboard/logs')} className={`menu-link ${window.location.pathname === '/admin/dashboard/logs' ? 'active' : ''}`}>
                    <span className='menu-link-icon'>
                      <MdManageSearch size={16} />
                    </span>
                    <span className='menu-link-text'>Logs</span>
                  </div>
                </li>
              )}
            </ul>
          )}
        </div>
      )}

      {/* PERFIL y CERRAR SESIÓN */}
      <div className='sidebar-menu sidebar-menu-bottom'>
        <ul className='menu-list'>
          <li className='menu-item'>
            <div onClick={logout} className='menu-link logout-link'>
              <span className='menu-link-icon'>
                <IoExit size={16} />
              </span>
              <span className='menu-link-text'>Cerrar sesión</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};
